// extracted by mini-css-extract-plugin
export default {"widget":"DashboardDataWidget_widget__w4-tY","sections":"DashboardDataWidget_sections__LdvZX","description":"DashboardDataWidget_description__sbj-K"};